import React from "react"
import { Form, useSearchParams } from "react-router-dom"
import { Api } from "../lib/api"
import { Input, Button, Link, Text, VStack, Heading } from "@chakra-ui/react"
import GradientBox from "./GradientBox"
import { addAlert, AlertType } from "@/lib/alerts"

export default function ResetPassword() {
  const [searchParams] = useSearchParams()
  const api = new Api()

  const user_id = searchParams.get("user_id")
  const timestamp = searchParams.get("timestamp")
  const signature = searchParams.get("signature")

  React.useEffect(() => {
    if (!user_id || !timestamp || !signature) {
      addAlert(
        AlertType.ERROR,
        "Password Reset",
        "Invalid password reset link. Please request a new one.",
      )
    }
  }, [user_id, timestamp, signature])

  const handlePasswordReset = (event) => {
    event.preventDefault()

    const password = event.target.password.value
    const password_confirm = event.target.password_confirm.value

    if (password !== password_confirm) {
      console.log("Passwords do not match")
      addAlert(AlertType.ERROR, "Password Reset", "Passwords do not match")
      return
    }

    const resetPassword = async () => {
      console.log("Sending password reset request")
      const resp = await api.accountsResetPassword(
        user_id,
        timestamp,
        signature,
        password,
      )
      return resp
    }
    const resp = resetPassword()
    if (!resp) {
      console.log("Reset failed")
      addAlert(AlertType.ERROR, "Password Reset", resp.detail)
      return
    }
    console.log("Reset success")
    resp.then((resp) => {
      addAlert(AlertType.SUCCESS, "Password Reset", getSuccessMessage(resp))
    })
  }

  const getSuccessMessage = (resp) => {
    return (
      <Text>
        {resp.detail}. <Link href="/">Click here to login</Link>
      </Text>
    )
  }

  return (
    <GradientBox>
      <VStack
        minWidth="100%"
        justifyContent="space-between"
        alignItems="left"
        mb="2em"
      >
        <Form onSubmit={handlePasswordReset}>
          <Heading variant="standardSub" color="white" mb="1em">
            Reset Password
          </Heading>
          <VStack
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            minWidth="100%"
            spacing="0"
          >
            <Text variant="subtext">Enter your new password</Text>
            <Input
              variant="account"
              type="password"
              name="password"
              id="password"
              isRequired
            />
            <Text variant="subtext" mt="1.5em">
              Re-type your new password
            </Text>
            <Input
              variant="account"
              type="password"
              name="password_confirm"
              id="password_confirm"
              isRequired
            />
            <Button variant="account" mt="2em" type="submit">
              Reset Password
            </Button>
          </VStack>
        </Form>
      </VStack>
      <span />
    </GradientBox>
  )
}
